import { render } from "./PerformanceReport.vue?vue&type=template&id=4fe635e9&scoped=true&ts=true"
import script from "./PerformanceReport.vue?vue&type=script&lang=ts"
export * from "./PerformanceReport.vue?vue&type=script&lang=ts"

import "./PerformanceReport.vue?vue&type=style&index=0&id=4fe635e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe635e9"]])

export default __exports__